import { CLOSE_POPUP, OPEN_POPUP, VIRTUALS_VIDEO_STREAM } from '@common/actionTypes';

export const OpenPopup = (key, payload) => ({
  type: OPEN_POPUP,
  key,
  payload,
});

export const ClosePopup = (locationChanged) => ({
  type: CLOSE_POPUP,
  locationChanged,
});

export const virtualsVideoStream = (payload) => ({
  type: VIRTUALS_VIDEO_STREAM,
  payload,
});
